import React from 'react';
import classnames from 'classnames';
import css from './theme-header.module.scss';

type Props = {
  color: string;
  logo: string;
};

const ThemeHeader = ({ logo, color }: Props) => {
  const classes = classnames(css.themeHeader, {
    [css.withLogo]: !!logo,
  });
  const style = color ? { backgroundColor: `#${color}` } : {};

  if (color || logo) {
    return (
      <div className={classes} data-testid="fr-theme-header" style={style}>
        {logo && (
          <div className={css.logoContainer}>
            <img
              alt=""
              className={css.logo}
              data-testid="theme-logo-image"
              src={logo}
            />
          </div>
        )}
      </div>
    );
  }
  return null;
};

export { ThemeHeader };
export default ThemeHeader;
